import { ThemeService } from '../../nav/theme.service';
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NavigationEnd } from '@angular/router';
import { ProgressService } from './services/progress.service';
import { OnboardingService } from './services/onboarding.service';
import { UiService } from 'src/app/core/services/ui.service';

@Component({
  selector: 'app-onboarding',
  standalone: false,
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
  host: {
    // Classic: host-level data-theme="dark" scopes the dark CSS variables. New UI: no host override,
    // so the dark palette comes from <html data-theme>, which ngOnInit still forces via setTheme('dark').
    '[attr.data-theme]': 'ui.isNew() ? null : "dark"'
  }
})
export class OnboardingComponent implements OnInit, OnDestroy {
  protected readonly router = inject(Router);
  protected readonly progressService = inject(ProgressService);
  protected readonly onboardingService = inject(OnboardingService);
  private readonly themeService = inject(ThemeService);
  protected readonly ui = inject(UiService);
  protected readonly destroy$ = new Subject<void>();

  protected isWelcomePage = false;

  ngOnInit(): void {
    this.themeService.setTheme('dark');
    this.updateWelcomePage();
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd), takeUntil(this.destroy$))
      .subscribe(() => this.updateWelcomePage());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateWelcomePage(): void {
    this.isWelcomePage = this.router.url.includes('welcome');
  }

  protected onBacktoLogin(): void {
    this.progressService.resetStepStates();
    this.onboardingService.resetAccountInformation();
  }
}
